export interface TeamSettings {
  planning?: {
    visibleShiftUnitIds?: string[];
  };
}
